import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilledApple = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9513 5.08367C14.2982 5.87496 13.1929 6.46529 12.3137 6.46529C12.2132 6.46529 12.1127 6.45273 12.0499 6.44017C12.0373 6.38993 12.0122 6.23921 12.0122 6.08849C12.0122 5.08367 12.5272 4.07886 13.0798 3.45085C13.7832 2.62188 14.9639 2.00643 15.9436 1.96875C15.9687 2.08179 15.9812 2.21995 15.9812 2.35812C15.9812 3.36293 15.5542 4.35518 14.9513 5.08367ZM15.6421 6.67881C16.1948 6.67881 18.1918 6.72906 19.4981 8.61308C19.385 8.701 17.4005 9.81886 17.4005 12.3183C17.4005 15.2072 19.9251 16.2371 20.0005 16.2622C19.9879 16.325 19.5986 17.6564 18.6691 19.0255C17.8401 20.2187 16.9609 21.4245 15.6421 21.4245C14.3107 21.4245 13.9716 20.6457 12.4518 20.6457C10.9572 20.6457 10.4296 21.4496 9.22386 21.4496C8.00552 21.4496 7.16399 20.3317 6.19686 18.9752C5.06644 17.3675 4.16211 14.8806 4.16211 12.5193C4.16211 8.73868 6.6239 6.72906 9.04802 6.72906C10.3292 6.72906 11.3968 7.57059 12.2132 7.57059C12.9794 7.57059 14.1726 6.67881 15.6421 6.67881Z",
		fill: "currentColor"
	})
});
export default SvgFilledApple;
